import {
    NAVIGATE_TO_CATEGORY_PAGE,
    NAVIGATE_TO_BASIC_DETAILS,
    NAVIGATE_TO_INCIDENT_DETAILS,
    NAVIGATE_TO_OTHER_DETAILS,
    NAVIGATE_TO_UPLOAD_DOCUMENTS,
    NAVIGATE_TO_CONFIRMATION,
    NAVIGATE_TO_SUCCESS_PAGE,
    SET_ACTIVE_PAGE_INDEX,
    SET_NAVIGATION_DONE,
    NAVIGATE_INDEX,
    SCROLL_TO_ID,
    CLEAR_SCROLL,
    CLAIM_NAME,
} from '../../actions/allSureMotorClaim/routing';

import { APP_NOT_INITIATED, PAGE_INDICES } from '../../actions/allSureMotorClaim/types';

export const initRouting = {
    activePageIndex: 0,
    claimName: null,
    doNavigation: false,
    doExitNavigation: false,
    parentAppUrl: null,
    callbackAction: null,
    parentApp: null,
    scrollToId: null,
};

export default (state = initRouting, action) => {
    const setActivePage = (pageIndex) => ({
        ...state,
        activePageIndex: pageIndex,
        doNavigation: true,
    });

    switch (action.type) {
        case NAVIGATE_INDEX:
            return {
                ...state,
                activePageIndex: action.value,
            };
        case SET_ACTIVE_PAGE_INDEX:
            return {
                ...state,
                doNavigation: true,
                activePageIndex: action.value,
            };

        case SET_NAVIGATION_DONE:
            return { ...state, doNavigation: false };

        case NAVIGATE_TO_CATEGORY_PAGE:
            return setActivePage(PAGE_INDICES.CATEGORY);

        case NAVIGATE_TO_BASIC_DETAILS:
            return setActivePage(PAGE_INDICES.BASIC_DETAILS);

        case NAVIGATE_TO_INCIDENT_DETAILS:
            return setActivePage(PAGE_INDICES.INCIDENT_DETAILS);

        case NAVIGATE_TO_OTHER_DETAILS:
            return setActivePage(PAGE_INDICES.OTHER_DETAILS);

        case NAVIGATE_TO_UPLOAD_DOCUMENTS:
            return setActivePage(PAGE_INDICES.UPLOAD_DOCUMENTS);

        case NAVIGATE_TO_CONFIRMATION:
            return setActivePage(PAGE_INDICES.CONFIRMATION);

        case NAVIGATE_TO_SUCCESS_PAGE:
            return setActivePage(PAGE_INDICES.SUCCESS);

        case CLAIM_NAME:
            return { ...state, claimName: action.value };

        case SCROLL_TO_ID:
            return { ...state, scrollToId: action.value };
        case CLEAR_SCROLL:
            return { ...state, scrollToId: null };
        default:
            return state;
    }
};
